import { InjectionToken } from '@angular/core';

export type DocViewDocType = 'event' | 'user';

export interface DocViewHandler {
    /** Open a preview modal/dialog for the given document */
    openPreview(docType: DocViewDocType, id: string): void;

    /** Get the router link segments for the given document */
    getLink(docType: DocViewDocType, id: string): string[];
}

/**
 * Optional injection token for handling doc_view column actions in report tables.
 *
 * Consuming apps can provide their own implementation:
 * - Kaizen: uses the AngularJS $uibModal event preview
 * - Assembly: may provide a simplified version or none at all
 *
 * When not provided, doc_view columns fall back to link-only rendering.
 */
export const DOC_VIEW_HANDLER = new InjectionToken<DocViewHandler>('DOC_VIEW_HANDLER');
